module.exports = __webpack_public_path__ + "img/msg03.e1962472.png";